<template>
  <el-container height="auto">
    <el-main>
        <el-form ref="form" :model="project"  :rules="rules" label-width="100px">
            <el-row >
              <el-col :span="24">
                <el-form-item label="研究名称">
                  <el-input v-model="project.name"></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-form-item label="研究说明" >
              <el-input type="textarea" v-model="project.description"></el-input>
            </el-form-item>

            <el-form-item label="手机访问" >
              <el-switch v-model="project.allowmobile"></el-switch>
            </el-form-item>

            <el-form-item style="text-align:center">
              <el-button type="primary" @click="onSave">保存</el-button>
            </el-form-item>
            
          </el-form>
    </el-main>
  </el-container>
</template>
<script>
  export default {
    data() {
      return {
        project: {
          name: '',
          description: '',
          allowmobile: '',
        },
        rules: {
          name: [
            { required: true, message: '请输入名称', trigger: 'blur' },
          ]
        },
      }
    },
    mounted(){
      this.loadProject();
    },
    methods: {
      onSave(){
          this.project.allowmobile = (this.project.allowmobile)?"1":"0";

          this.$http.post('project/edit', this.project).then((res) => {
              if(!res) return;

              //提醒成功
              this.$message({ type:'success', message:'保存成功'})
              
              //清除内容
              var info = res.data.info;
              info.allowmobile = ((info.allowmobile||"0") == "1")?true:false;
              this.project = info;

              this.$router.push({ path: '/home/project', query:{}})
          }); 
      },
      
      loadProject(){
        this.$http.get('project/info', {params:{id:this.$route.query['id']}}).then((res) => { 
            if(!res) return;

            var info = res.data.info;
            info.allowmobile = ((info.allowmobile||"0") == "1")?true:false;
            this.project = info;

              }); 

            
        
      }
    }
  }
</script>
<style scoped>

</style>